import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { SiteVisit } from 'Portals/Supplier/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<SiteVisit.Basic>> =>
	Http.get(`${baseUrl}/supplier-visit`, { params })

export const downloadDocument = (id: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/download/${id}`, {
		responseType: 'blob'
	})

export const retrieveAvailableSupplierLocations = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/available-supplier-locations`)
